"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CustomLandingPage", {
  enumerable: true,
  get: function get() {
    return _$previous.CustomLandingPage;
  }
});
Object.defineProperty(exports, "SpotlightCarousel", {
  enumerable: true,
  get: function get() {
    return _$previous.SpotlightCarousel;
  }
});
exports.DefaultCatalogGroupPage = exports.default = void 0;

var _$previous = _interopRequireWildcard(require("$previous"));

var _decorators = require("decorators");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _Cart = babelHelpers.interopRequireDefault(require("Cart"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _default = _$previous.default;
exports.default = _default;

var DefaultCatalogGroupPage = /*#__PURE__*/function (_BasePage) {
  babelHelpers.inherits(DefaultCatalogGroupPage, _BasePage);

  var _super = _createSuper(DefaultCatalogGroupPage);

  function DefaultCatalogGroupPage() {
    babelHelpers.classCallCheck(this, DefaultCatalogGroupPage);
    return _super.apply(this, arguments);
  }

  return DefaultCatalogGroupPage;
}(_$previous.DefaultCatalogGroupPage);

exports.DefaultCatalogGroupPage = DefaultCatalogGroupPage;